// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1xdvW","col":"Table_col__10uWT","fulfillmentStatus":"Table_fulfillmentStatus__YBmUd","emailCol":"Table_emailCol__3Gq-v"};